import React, { Component } from 'react';
import { Row, Form, Input, Col, Button, Card, message } from 'antd';
import { Link, withRouter } from 'react-router-dom';
import { addNewOraganization } from '../../api/OraganizationApis';
import { withAppContext } from '../../store/contextStore';
import LocationAutocomplete from "../../Components/Autocomplete";

class AddOraganization extends Component {
  state = {
    loading: false,
  };


  handleOnChange = event => {
    this.setState({
      [event.target.id]: event.target.value,
    });
  };
  getAddress = e => {
    this.props.form.setFieldsValue({
      address: e,
    });
  };

  addOraganization = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.setState({
          loading:true
        })
        let entityData = {
          orgName: values.orgName,
          phone: values.phone,
          email: values.email,
          cityCode: null,
          stateCode: null,
          address: values.address
        }
        const data = {
          entityData: entityData,
        };
        console.log(data);
        // return;
        addNewOraganization(data)
          .then(result => {
            if (result.success) {
              message.success("Organization created successfully");
              window.location.href = '/app/oraganizations';
            } else {
              console.log(result.errors);
              message.error("Organization creation failed");
              this.setState({
                loading:false
              })
            }
          });

        console.log(this.state);
      }
    });
  };

  hasErrors = fieldsError => Object.keys(fieldsError).some(field => fieldsError[field]);

  setNewValue = (newValue) => {
    console.log('this is the State code:' + newValue);

    this.setState({
      stateCode: newValue,
    });
  }
  render() {
    const { getFieldDecorator } = this.props.form;

    return (
      <div style={{  top: '135px', width:"800px",margin:"auto" }}>
          <Row style={{ margin: "40px 20px" }}>
            <div>
              <Form onSubmit={this.addOraganization}>
                <div>
                  <Col lg={24} md={24} sm={24} xs={24} style={{ marginBottom: "10px" }}>
                    <Button type="primary" htmlType="submit" loading={this.state.loading} onClick={this.addOraganization} style={{ float: 'right', backgroundColor: '#255595', color: 'white', marginRight: '30px', padding: '0 20px 0 20px' }}   >
                      Save
                    </Button>
                    <Button type="primary" style={{ float: 'right', backgroundColor: '#25559517', color: '#255595', marginRight: '30px', padding: '0 20px 0 20px', border: 'none' }}>
                      <Link to="/app/Oraganizations">
                        Cancel</Link>
                    </Button>
                  </Col>
                  <Col lg={24} md={24} sm={24} xs={24}>
                    <div className="site-card-border-less-wrapper">
                      <Card title="Add Organization" style={{ borderRadius: '10px'}}>
                        <Row gutter={8}>
                          <Col lg={24} md={24} sm={24} xs={24}>
                            <Form.Item className="Formitem"
                              label={<span style={{ color: '#0E4D90' }}>Org Name</span>} >
                              {getFieldDecorator('orgName', {
                                rules: [{ required: true, message: 'Please input your Org Name' }],
                              })(<Input />)}
                            </Form.Item>
                          </Col>
                          <Col lg={24} md={24} sm={24} xs={24}>
                            <Form.Item className="Formitem"
                              label={<span className="label">Address</span>}>
                              {getFieldDecorator('address', {
                                rules: [{ required: true, message: 'Please input your Address!' }],
                              })(<LocationAutocomplete getAddress={(address,latLng) => this.getAddress(address,latLng, 'address')} editMode={false}/>)}
                            </Form.Item>
                          </Col>
                          <Col lg={24} md={24} sm={24} xs={24}>
                            <Form.Item className="Formitem"
                              label={<span style={{ color: '#0E4D90' }}>Phone</span>} >
                              {getFieldDecorator('phone', {
                                rules: [{ required: true, message: 'Please input phone number' }],
                              })(<Input />)}
                            </Form.Item>
                          </Col>
                          <Col lg={24} md={24} sm={24} xs={24}>
                            <Form.Item className="Formitem"
                              label={<span style={{ color: '#0E4D90' }}>Email</span>} >
                              {getFieldDecorator('email', {
                                rules: [{ required: true, message: 'Please input email' }],
                              })(<Input />)}
                            </Form.Item>
                          </Col>
                        </Row>
                      </Card>
                    </div>
                  </Col>
                </div>
              </Form>
            </div>
          </Row>
      </div>
    );
  }
}

const AddCompanyForm = Form.create({ name: 'AddOraganization' })(withAppContext(withRouter(AddOraganization)));

export default AddCompanyForm;